import {decamelize} from 'humps';

import {OperationParams, OperationsRequestParams} from 'shared/models/task/filter';

import {prepareTaskFilters} from './tasks';

export function prepareOperationsRequestParams({
  limit = 20,
  offset = 0,
  params = {},
  sortField,
  sortOrder,
  cancelToken,
}: OperationParams = {}): OperationsRequestParams {
  return {
    filterParams: prepareTaskFilters(params),
    rangeParams: [offset, limit],
    sortParams: sortField || sortOrder ? [sortField ? decamelize(sortField) : undefined, sortOrder] : undefined,
    cancelToken,
  };
}
